import type { AuditPackage, ProjectProfile } from '@/lib/types'

// Phase 1 mock data. Will be replaced by Lumi entities in a later phase.

export const AUDIT_PACKAGES: AuditPackage[] = [
  {
    tier: 'starter',
    name: 'Smart Contract Audit',
    priceUsd: 250,
    promoPriceUsd: 150,
    turnaround: '7-10 business days',
    highlight: true,
    features: [
      'Comprehensive vulnerability assessment',
      'Audit score 1-100',
      'Full vulnerability report',
      'Verified badge on profile',
      'Downloadable PDF audit report',
      'Shareable social media card',
    ],
  },
]

export const MOCK_PROFILES: ProjectProfile[] = [
  {
    _id: 'p1',
    name: 'Mandox',
    symbol: 'MANDOX',
    chain: 'ethereum',
    contractAddress: '0x7a8adcf432ebcc2311b955d176ee4bfed13bb9a7',
    description:
      '$MANDOX is an ERC-20 utility token on the Ethereum Blockchain, powering the Mandox Ecosystem and the Mandox Audits platform at Mandox.io.',
    bio:
      '$Mandox is an ERC-20 Token on the Ethereum Blockchain. $Mandox token is the utility token of the Mandox Ecosystem. Discover more on our website. Mandox is the proud owner of Mandox Audits at Mandox.io.',
    bannerUrl: '',
    logoUrl: 'https://static.lumi.new/2e/2ebbe4cd871f75f1dee582d4576bd613.webp',
    social: {
      website: 'https://www.MandoxToken.com',
      twitter: 'https://x.com/OfficialMandox',
      telegram: 'https://t.me/officialmandox',
    },
    packageTier: 'starter',
    audit: null,
    creator: 'user_mandox',
    createdAt: '2025-07-01T10:00:00.000Z',
  },
]
